import axios from '../../axios';

const service = {
  fetchBreeds() {
    return axios({ method: 'get', url: '/animals/breeds' });
  }
};

export default service;
